import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { SplService } from './spl.service';

@Injectable()
export class SplGuard implements CanActivate {

    constructor(
        private splService: SplService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.splService.getSpl(this.applicationService.caseId).pipe(map(() => true));
    }
}
